import React, {Component, Fragment} from 'react';
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import * as RoleType from "../../../constants/user/RoleType";
import {showCommentBlockPopup, showCommentReplyPopup} from "../../../actions/popup";
import {connect} from 'react-redux'
import classnames from "classnames";
import CommentStatusButtonItem from "../CommentStatusChangeButton";
import If from "../../common/control/If";
import autobind from "autobind-decorator";
import * as querystring from "querystring";
import {receiveItems, updateItem} from "../../../actions/comment/guestbookComment";
import {addPrefix} from "../../../utils/UriUtil";


@connect(state => ({
  activatedId: state.guestbookComment.moreButton.activatedId,
  currentUserId: state.user.userId,
  currentUserRole: state.user.role,
}), dispatch => ({
  handleReceiveItems: (items, totalCount) => {
    dispatch(receiveItems(items, totalCount))
  },
  handleShowCommentBlockPopup: (id) => {
    dispatch(showCommentBlockPopup(id))
  },
  handleUpdateItem: (item) => {
    dispatch(updateItem(item))
  },
  handleShowCommentReplyPopup: (id) => {
    dispatch(showCommentReplyPopup(id))
  },
  dispatch
}))
class GuestBookCommentListItemButton extends Component {

  constructor(props) {
    super(props);
  }

  @autobind
  updateItemStatus(item, changes) {
    const {handleUpdateItem, dispatch} = this.props;
    fetch(addPrefix("/manage/guestBookComment/" + item.id + "/approval.json"), {
      method: "put",
      credentials: "include",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: querystring.stringify(
        Object.assign({}, changes)
      )
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        item.processing = false;
        handleUpdateItem(item);
      })
      .catch(e => {
        item.processing = false;
        console.log(e)
      })
  }

  @autobind
  handleMoveToTrash() {
    const {item, currentUserRole, handleUpdateItem, dispatch} = this.props;
    const hasRole = RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), RoleType.EDITOR);
    let canManage = !(!item.editable || !hasRole);

    if (!canManage) {
      alert('편집자 이상의 권한이 필요합니다.');
    } else {
      item.deleting = true;
      handleUpdateItem(item);
      fetch(addPrefix("/manage/guestBookComment/" + item.id + ".json"), {
        method: "delete",
        credentials: "include",
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      })
        .then(jsonResponseHandler(dispatch))
        .then(data => {
          this.reFetchItems();
        })
        .catch(e => {
          item.deleting = false;
          handleUpdateItem(item);
          console.log(e)
        })
    }
  }

  @autobind
  handleReject(item) {
    item.visibility = 0;
    item.isApproved = false;
    item.processing = true;
    this.updateItemStatus(item, {visibility: 0});
  }

  @autobind
  handleApprove(item) {
    item.visibility = 2;
    item.isApproved = true;
    item.processing = true;
    this.updateItemStatus(item, {visibility: 2});
  }

  reFetchItems() {
    const {handleReceiveItems, dispatch} = this.props;
    fetch(addPrefix("/manage/guestBookComments.json" + location.search), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleReceiveItems(data.items, data.totalCount);
      })
      .catch(e => {
        console.log(e)
      })
  }

  handleBlock() {
    const {item, handleShowCommentBlockPopup} = this.props;
    const {currentUserRole, currentUserId} = this.props;
    const hasRole = RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), RoleType.EDITOR);
    let canManage = !(!item.editable || !hasRole);

    if (item.authorId === currentUserId) {
      alert('본인이 작성한 글은 차단할 수 없습니다.');
    }
    else {
      if (!canManage) {
        alert('편집자 이상의 권한이 필요합니다.');
      } else {
        handleShowCommentBlockPopup(item.id);
      }
    }
  }

  handleReply(e, item) {
    e.preventDefault();
    const {handleShowCommentReplyPopup, useCommentRecognition} = this.props;


    if (item.parent !== null) {
      alert('답글에는 답글을 작성할 수 없습니다.');
      return false;
    }

    if (parseInt(useCommentRecognition) === 0) {
      handleShowCommentReplyPopup(item.id);
    }
    else {
      (item.isApproved)
        ? handleShowCommentReplyPopup(item.id)
        : alert('승인되지 않은 방명록 글에는 댓글을 작성할 수 없습니다.');
    }
  }

  render() {
    const {item, useCommentRecognition, currentUserRole, currentUserId} = this.props;
    const hasRole = RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), RoleType.EDITOR);
    const canReply = item.parent === null && !((parseInt(useCommentRecognition) === 1) && (!item.isApproved)) && hasRole;
    const isMyComment = item.authorId === currentUserId;

    return <Fragment>
      <If condition={useCommentRecognition}>
        <CommentStatusButtonItem
          handleApprove={this.handleApprove}
          handleReject={this.handleReject}
          item={item}
        />
      </If>
      <a href="#" className={classnames(`btn_post`, {'disabled': !canReply})} onClick={(e) => this.handleReply(e, item)}>답글</a>
      <a href="#" className={classnames(`btn_post`, {'disabled': isMyComment})} onClick={(e) => this.handleBlock(e, item)}>차단</a>
      <a href="#" className="btn_post" onClick={(e) => this.handleMoveToTrash(e, item)}>휴지통</a>
    </Fragment>
  }
}

export default GuestBookCommentListItemButton;
